import Joi from "joi";

export default Joi.object({});
